export default __webpack_public_path__ + "static/scam-hub-jan-march-2026-d7f295857542ff0a33b1d29fdd360206.webp";